exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading{display:flex;justify-content:space-between}#menuFilter{margin-top:15px!important;background:#fff;position:absolute;z-index:250;max-height:360px!important}#menuFilter .panel-body{max-height:300px!important;overflow:auto}#menuFilter .panel-block{background-color:#fff}#menuFilter .is-active{border-left:3px solid #41aae7;color:#363636;background:#f0f8ff}.panel-block .panel-icon .material-icons{line-height:unset!important}.tooltipName{z-index:251}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67e2fafc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/components/menuFiltersHistoric.vue
// module id = 2116
// module chunks = 2